export default {"src":"/uk/_next/static/media/up-filled.9f30798d.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};